<script lang="ts" setup>
import { ref } from 'vue';
import { CustomerMgmtTypes, useEditUser } from '@ilteducation/customer-mgmt';
import { SelfConfirmTextField } from '@ilteducation/text-field/self-confirmed-text-field';
import { maxLength, minLength, username as usernameRule } from '../../../../rules/index';
import { useLocale } from '../../../../composables/useLocale';
import { createErrorParser } from '../../../../error-utils';

type Props = {
  loading?: boolean;
  disabled?: boolean;
  user: CustomerMgmtTypes.GetUserResponse;
};
const props = defineProps<Props>();

type Emits = {
  (e: 'updated'): void;
};
const emits = defineEmits<Emits>();
const { t } = useLocale();
const model = defineModel<string>();
const { updateUser, isLoading, error } = useEditUser();

const requestErrorMessage = ref<string>();
const saveUsername = async (newUsername: string) => {
  if (!props.user) return false;

  requestErrorMessage.value = undefined;

  const successful = await updateUser(props.user.uid, { userName: newUsername });
  if (successful) {
    emits('updated');
  } else {
    requestErrorMessage.value = createErrorParser(t, { 409: 'lcp.errors.username_already_taken' })(error.value);
  }

  return successful;
};
</script>
<template>
  <SelfConfirmTextField
    :model-value="model"
    prepend-inner-icon="mdi-account"
    :label="t('lcp.username')"
    :disabled="disabled || loading"
    :loading="isLoading || loading"
    :onApprove="saveUsername"
    :rules="[usernameRule(t), minLength(3, t), maxLength(255, t)]"
    :color="requestErrorMessage ? 'error' : undefined"
    :messages="requestErrorMessage"
  >
    <template v-if="requestErrorMessage" v-slot:message>
      <!--
      Why not error-message but force message to looks like error?
      SelfComfirmedText has a comfirmation button gets disabled if validation fails. Veutify validation accepts "error-messages" as validation error.
      Therefore users lose oppurtunity to try again on an error.
       -->
      <div class="text-error text-caption">{{ requestErrorMessage }}</div>
    </template>
  </SelfConfirmTextField>
</template>
